// extracted by mini-css-extract-plugin
export default {"studentStrip":"StudentStrip_studentStrip__vOZHP","strong":"StudentStrip_strong__MrsLx","row":"StudentStrip_row__8DXuL","logout":"StudentStrip_logout__GHQHQ"};